import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const SEARCH_HOTELS_URL = "https://cached.canary.perfectstay.io/search-hotels";

const fetchSearchHotels = ({ q, partnerCode, limit }) =>
	axios.get(SEARCH_HOTELS_URL, { params: { q, limit, partnerCode } }).then(res => res.data);

export const useSearchHotels = ({ q = "", partnerCode, limit = 20 }) =>
	useQuery({
		queryKey: ["searchHotels", q, partnerCode, limit],
		queryFn: () => fetchSearchHotels({ q, partnerCode, limit }),
		enabled: Boolean(partnerCode) && q.length > 0,
		staleTime: 1000 * 60 * 5,
	});
